// 该文件为自动生成，请不要直接修改该文件(直接修改该文件,送翻后修改会失效)
/* eslint-disable */
export default {
  "3259583117": "Notifica al client il reindirizzamento.",
  "1d484fee4a": "Dipartimento Finanziario, Dipartimento Vendite, Gestione Progetti, Dati Aziendali, Dipartimento Prodotti, Dipartimento Operazioni, Gestione R&S, Pianificazione Versioni, Dipartimento Servizio Clienti, Dipartimento Amministrativo, Dipartimento Acquisti, Gestione Post-vendita",
  "a2c88dfb79": "Crea il tuo primo team",
  "3cfdcc6086": "Dipartimento Finanziario, Dipartimento Vendite, Gestione Progetti/305, Amministrazione Risorse Umane/306, Dipartimento Operazioni, Gestione R&S, Pianificazione Versioni, Gestione Servizio Clienti/403, Dipartimento Acquisti, Gestione Post-vendita",
  "ac45ec2c05": "Verifica accesso account fallita.",
  "9aef9b8ccd": "L'account attualmente connesso è anomalo. Accedi nuovamente e riprova.",
  "728dd00f22": "La verifica di questo numero di telefono è anomala. Prova ad accedere utilizzando un codice di verifica SMS.",
  "30dbecd916": "Le informazioni inserite contengono parole sensibili. Modificale e riprova.",
  "12ed508d8a": "La tua operazione è troppo frequente. Riprova più tardi.",
  "952d4a7595": "Lo stato di accesso dell'account corrente è anomalo. Accedi nuovamente e riprova.",
  "e64bfdeaa4": "Verifica dell'accesso non riuscita. Richiedi nuovamente la verifica tramite SMS.",
  "79008a65f1": "Questo numero di telefono è già associato a più aziende. Accedi all'azienda o cambia numero di telefono.",
  "bf242eff42": "Nome azienda già esistente.",
  "4f0cdb8374": "Inserisci il numero di telefono completo. Se utilizzi un numero estero, cambialo con un numero nazionale (86+).",
  "46e79ffeff": "Errore durante la creazione dell'azienda. Contatta il servizio clienti ufficiale per la risoluzione.",
  "f3e18f0341": "Verifica parametri fallita.",
  "503fd1718d": "Invio codice di verifica SMS non riuscito.",
  "24b3129f19": "Invio SMS troppo frequente. Riprova più tardi.",
  "1cde3e8245": "Codice di verifica errato. Inseriscilo nuovamente.",
  "4212ecc031": "Sono stati riscontrati più errori di verifica. La verifica è temporaneamente limitata. Riprova più tardi.",
  "735da9c347": "Errore nella verifica di nomi azienda duplicati. Contatta il servizio clienti ufficiale per la risoluzione.",
  "8731da9615": "Errore nella verifica dell'autenticazione del nome azienda. Contatta il servizio clienti ufficiale per la risoluzione.",
  "62e89b3f16": "Accetto i termini di servizio.",
  "c9b79027e5": "Invia codice di verifica.",
  "84c1447b9d": "Copia riuscita.",
  "fba4b0abd0": "Record host",
  "37f5a7cd41": "Valore TXT",
  "78b12427c9": "Verifica in corso...",
  "59d089837c": "Al momento non è possibile verificare il tuo dominio. Potrebbe essere necessario attendere un po' di tempo affinché il provider di hosting del dominio aggiorni le tue informazioni. Se dopo un po' di tempo non ci sono ancora risposte, prova a verificare di nuovo o a cambiare il dominio.",
  "4a5b7383d1": "Verifica del dominio in corso",
  "f24a492e40": "i record di verifica, puoi chiudere questa pagina e tornare più tardi per controllare.",
  "c697ca5f1a": "Benvenuto nella versione Enterprise",
  "ebb01b1740": "Avanti",
  "30109bf753": "La tua azienda ha un nome di dominio?",
  "2b3e485b47": "Ho un nome di dominio aziendale",
  "1a7f5eae44": "Non ho un nome di dominio aziendale",
  "bde15d6d84": "È necessario disporre di un nome di dominio (ad es. example.com) per creare un account aziendale.",
  "07ffb22c90": "Spiacenti, è necessario disporre di un nome di dominio per creare un account aziendale per la tua azienda.",
  "de23836563": "Inserisci il nome di dominio da utilizzare per creare l'account aziendale.",
  "287c07944a": "Verifica il tuo nome di dominio",
  "3ea2d528d5": "Completa i seguenti passaggi per dimostrare di essere il proprietario di <b>{domain}</b> e impedire a chiunque altro di utilizzare questo dominio per registrare un account aziendale.",
  "082b18ce56": "a. Apri il sito web del provider di hosting del dominio in una <b>nuova scheda</b>, quindi <b>accedi</b> al tuo account;",
  "4f7e0841a9": "b. Sul sito web del provider di hosting del dominio, vai alla <b>sezione Record DNS</b>. Sulla pagina del tuo provider di hosting del dominio, il nome della sezione Record DNS potrebbe variare, ad esempio potrebbe essere visualizzato come <b>DNS Management (Gestione DNS), Name Server Management (Gestione server nomi), Control Panel (Pannello di controllo) o Advanced Setting (Impostazioni avanzate).</b>",
  "6365ad6e3a": "Successivamente, <b>torna qui</b>, quindi fai clic su \"Avanti\" per aggiungere i record di verifica.",
  "8528892080": "Aggiungi record di verifica",
  "7a225304f8": "a. Nella pagina DNS, scorri fino alla sezione <b>TXT</b>, quindi fai clic sul pulsante pertinente per aggiungere un record;",
  "b3cb7d947c": "b. <b>Copia e incolla</b> tutti i valori seguenti nel <b>modulo TXT</b> sul sito web del provider di hosting del dominio;",
  "47213583bf": "c. <b>Salva</b> il record sul sito web del provider di hosting del dominio,<br>quindi <b>torna qui</b> e fai clic su \"Verifica dominio\" qui sotto.",
  "21486a57cf": "Nota: Nel campo Nome/Host/Alias, puoi inserire \"@\" o lasciarlo vuoto. Il provider di hosting del dominio potrebbe anche richiedere di inserire il nome di dominio (<il tuo dominio>.com) in questo campo. Potresti essere in grado di determinare come compilare questo campo basandoti su altri record DNS. Nel campo Time To Live (TTL), inserisci \"86400\" o mantieni il valore predefinito.",
  "f1b8edab9c": "Cambia dominio",
  "7c6fc663a8": "Verifica dominio",
  "b6aee9dc0d": "Dominio verificato con successo",
  "dd4cc429ea": "È stato dimostrato che sei il/la",
  "450f5c9230": "proprietario/a di e che nessun altro può utilizzare questo dominio per registrare un account aziendale.",
  "71cbcba755": "Fai clic su \"Avanti\" per completare la creazione dell'account aziendale.",
  "f4084f4870": "Imposta il tuo account di accesso",
  "fe3138baec": "Completa creazione",
  "0315cddedb": "Azienda creata con successo",
  "91454a7f34": "Accedi ora alla Console di amministrazione per creare account aziendali per i tuoi membri.",
  "366304cde7": "1. Verrà eseguito automaticamente il logout dall'account WPS attualmente in uso.",
  "8a9f2a8422": "2. È necessario utilizzare l'account aziendale {account}@{domain} per accedere alla Console di amministrazione.",
  "43e265e998": "Accedi alla Console di amministrazione",
  "9240efaaf0": "SMS inviato",
  "e424bb9a6d": "Inserisci",
  "d44d581706": "Nome azienda",
  "aa8679f406": ", 4-30 caratteri",
  "581bdb1f98": ", non può contenere i caratteri speciali \\/:*?\"<>|{}",
  "c13cabb67a": "Email",
  "2b9b429e46": "La tua email",
  "5ed834a7df": "Inserisci la tua email",
  "acfd1f02ed": "Inserisci un'email valida",
  "31c7c92cca": ", massimo 80 caratteri",
  "3f27cf84b3": "Inserisci il codice di verifica",
  "a0ae1f3ec4": "Codice di verifica errato",
  "e5589c5e74": "Il tuo nome",
  "69d7bd63f6": "Solo caratteri cinesi, lettere e numeri.",
  "91f008d258": "Massimo 8 caratteri.",
  "6ea6c9b39b": "Numero di telefono",
  "161042c5b7": "Inserisci il numero di telefono",
  "e6b8eab1cd": "Inserisci il numero di telefono, 11 cifre",
  "3fd5fbb3cc": "Inserisci il tuo nome di dominio",
  "cb5346ba8e": "Inserisci il nome di dominio aziendale corretto, 4-30 caratteri",
  "27928eb7a4": "Account",
  "8e19bd444d": "Inserisci il nome account per l'accesso",
  "7bbbf479dc": "4-20 caratteri, solo numeri, lettere o trattini bassi",
  "3d84cae479": "Inserisci un account che soddisfi i requisiti / il primo carattere deve essere una lettera o un numero",
  "c0d5ece1a7": "Password",
  "f444036fa8": "Inserisci la password",
  "b03218d72b": "La password deve essere di 12-16 caratteri e includere una combinazione di almeno tre dei seguenti tipi: lettere maiuscole, lettere minuscole, numeri o simboli.",
  "b4ab05df50": "*Qualcuno nella tua organizzazione ha già utilizzato il tuo nome di dominio per un account aziendale. Contatta il servizio clienti (400-677-5005) per dimostrare la proprietà di questo dominio.",
  "c58876008f": "Copia non riuscita, riprova.",
  "86f73420de": "Link di invito",
  "a58861962c": "Spiacente, il tuo browser attuale non supporta il download di questo codice QR.",
  "228db07f78": "Dipartimento Finanziario, Dipartimento Vendite, Gestione Progetti, Dati Commerciali, Dipartimento Prodotti, Dipartimento Operazioni, Gestione R&S, Pianificazione Versioni, Dipartimento Servizio Clienti, Dipartimento Amministrativo, Dipartimento Acquisti, Gestione Post-vendita",
  "93896d7e98": "Dopo aver creato un team, inizia a collaborare con i colleghi.",
  "e8f66fb75c": "Dipartimento Finanziario, Dipartimento Vendite, Gestione Progetti/305, Amministrazione Risorse Umane/306, Dipartimento Operazioni, Gestione R&S, Pianificazione Versioni, Gestione Servizio Clienti/403, Dipartimento Acquisti, Gestione Post-vendita",
  "831b73da9b": "Il nome non può contenere caratteri non validi o simboli speciali /\\;:*?\"<>|%&",
  "51ab33b3ee": "Parametro non corretto",
  "a297f9e951": "Nome azienda duplicato",
  "04d60ed5f5": "Non è possibile utilizzare parole proibite.",
  "2ff7bef083": "Formato del dominio non valido",
  "41e1ba2165": "Verifica delle informazioni TXT del dominio non riuscita",
  "50f348caa9": "Account già esistente",
  "9d4c950d65": "Questo nome è già registrato",
  "38cf19ed95": "Questo nome organizzazione esiste già",
  "4b426e7c9c": "Nome organizzazione",
  "298f880e18": "Esiste già, ti suggeriamo di fornire ulteriori informazioni:",
  "1e67dd20b3": "Recupera nome organizzazione",
  "517107cb04": "Usa un altro nome",
  "5667081882": "Crea con questo nome",
  "e306a979a6": "Compilazione rapida:",
  "f583db96e0": "*Se il nome dell'organizzazione è già in uso, puoi",
  "9767148e34": "Inserisci il nome dell'azienda o dell'organizzazione, 4-100 caratteri.",
  "e0e0ec159f": "Nome organizzazione",
  "5b13d254c0": "Questo nome azienda esiste già",
  "92027671ec": "Nome azienda",
  "36d482a7fb": "Recupera nome azienda",
  "79058a7577": "*Se il nome dell'azienda è già in uso, puoi",
  "c96dd48dba": "Nome azienda",
  "842efad336": "*Se sei un dipendente dell'azienda, ti preghiamo di",
  "860f9bd77b": "Contatta il servizio clienti",
  "5a7ed18daf": "Unisciti all'azienda",
  "ab470e9ace": "Lascia le informazioni di contatto",
  "0a7e0e48a7": "Nome dell'azienda richiedente:",
  "a8dc318dcc": "Si prega di verificare le informazioni di contatto inserite; il servizio clienti della piattaforma la chiamerà a breve.",
  "6ea1f4d7f5": "Invia dati",
  "d439e39f43": "Abbiamo ricevuto i suoi dati.",
  "884653426b": "Il servizio clienti la chiamerà entro 24 ore. Si prega di rispondere!",
  "2361cb14bf": "Scansiona il codice QR di WeChat per aggiungere il servizio clienti online e verificare lo stato di avanzamento.",
  "50f45d0031": "Salvataggio non riuscito",
  "fc856d0fd2": "Super amministratore",
  "e16c0676d2": "Amministratore",
  "b1d2ddd126": "Membro ordinario",
  "9d322cc08d": "Il nome dell'organizzazione non può contenere simboli speciali \\/:*?\"<>|{}.",
  "b583ba7363": "Il nome dell'azienda non può contenere simboli speciali \\/:*?\"<>|{}.",
  "1d118a9bad": "Il nome dell'organizzazione deve contenere almeno 4 caratteri. Inserire un nome di organizzazione di 4-100 caratteri.",
  "441b45b1f5": "Il nome dell'azienda deve contenere almeno 4 caratteri. Inserire un nome di azienda di 4-100 caratteri.",
  "97457cb1f0": "Il nome dell'organizzazione ha superato i 100 caratteri. Inserire un nome di organizzazione di 4-100 caratteri.",
  "8ce00d3b92": "Il nome dell'azienda ha superato i 100 caratteri. Inserire un nome di azienda di 4-100 caratteri.",
  "a72778d3de": "Il nome deve contenere almeno 2 caratteri. Inserire un nome di 2-10 caratteri.",
  "79c17db5de": "Il nome ha superato i 10 caratteri. Inserire un nome di 2-10 caratteri.",
  "482a118202": "Il nome supporta solo caratteri cinesi, numeri, caratteri inglesi e ·.",
  "9a9be18941": "Selezionare",
  "e6b7c4aa66": "Accordo di servizio online",
  "595023d905": "Crea organizzazione",
  "ba8c2df551": "Crea azienda",
  "d284384975": "Accordo di servizio online",
  "5c266d5a84": "Informativa sulla privacy",
  "fcb92dbcf6": "Accordo sui servizi di Ufficio Cloud",
  "2ae7a8a3f7": "Grazie per aver scelto il servizio WPS 365 Cloud Office. Di seguito vengono presentati principalmente gli accordi legali stipulati tra Lei e/o l'organizzazione che rappresenta e WPS Office, relativi alla registrazione, all'abbonamento e all'utilizzo di questo servizio.",
  "d30a6983bd": "La preghiamo di leggere {0} | {1} | {2}. Cliccando su «Accetto», si considera che Lei abbia accettato il contenuto di tale accordo e accettato i nostri servizi.",
  "263e306ede": "Ho letto e accetto {0} | {1} | {2}",
  "440129c0f1": "Inserisci {0}",
  "8ab916983d": "Nome dell'organizzazione",
  "b01d68543b": "Nome",
  "684b30d4e9": "Numero di cellulare",
  "a48427e8e2": "Utilizzato per creare una piattaforma di lavoro per la tua azienda.",
  "3a81b0f1fc": "Per facilitare i colleghi a trovarti nel sistema e collaborare.",
  "52bc539b6e": "Conferma creazione",
  "b2fe245e19": "Crea organizzazione/team: Condivisione file e collaborazione",
  "893282d3f7": "Si prega di fornire le informazioni sull'organizzazione:",
  "cc997bf6aa": "Conferma",
  "50fdde51ac": "{0}, da {1} a {2} caratteri",
  "a19cc5ec18": "{0}, non può contenere simboli speciali \\u005C/:*?\"<>|{}",
  "26857f28f9": "{0}, può contenere solo lettere, numeri e caratteri cinesi",
  "f4080b1431": "{0}, massimo {1} caratteri",
  "88e59b2d58": "{0}, 11 cifre",
  "91d6d4e105": "Inserisci codice di verifica",
  "bec71bde96": "Codice di verifica non corretto",
  "e20ff8ee19": "{0} obbligatorio",
  "8dc09d10d7": "dwId non trovato",
  "a03766ce6c": "Scuola",
  "03542addfe": "Organizzazione",
  "adb8a815d1": "Il numero di telefono ha raggiunto il limite massimo di {0} associati.",
  "97a6b66f1d": "Il numero di telefono attuale è già associato a {0}.",
  "665e465487": "Impossibile creare {0}, il numero di telefono attuale “<strong>{1}</strong>” ha raggiunto il limite massimo di {0} associati (è possibile associare un massimo di 5 {2}). Puoi accedere ai {3} già associati qui sotto:",
  "a85b1367ca": "Il numero di telefono attuale “{0}” è già associato a {1}. Puoi scegliere di accedere con un {2} esistente o crearne un nuovo {3}:",
  "bf992ce17b": "Crea {0} utilizzando un altro numero di telefono.",
  "395ea04444": "Crea un nuovo {0}.",
  "4ce3bb86b3": "Il numero di {0} aggiunti ha superato il limite.",
  "df88c4b7a5": "Il numero di telefono attuale “{0}” ha raggiunto il limite massimo di {1} associati.",
  "78f7dd59ca": "Il numero di telefono attuale “{0}” è associato ai seguenti {1}. Puoi passare direttamente a uno di essi.",
  "8db491a3f8": "Continua a creare un nuovo {0}.",
  "83f6d9e1e4": "Riprova.",
  "1dc5f11612": "O",
  "217d76f53e": "Segnala un problema.",
  "b69a6ea62a": "Tieni premuto il tasto sinistro del mouse per grattare via i due scudi.",
  "3a31f64800": "Congratulazioni, hai grattato via lo scudo.<br/>Continua con il passaggio successivo.",
  "6a81fcee96": "Caricamento in corso...",
  "e97877a65d": "Ops, lo scudo è sparito.<br/>Per favore,",
  "8d85456145": "Ho aspettato troppo a lungo.<br/>Per favore,",
  "77ad847b95": "La rete è davvero debole.<br/>Per favore,",
  "dbd1ae3a34": "Hai grattato troppo velocemente.<br/>Per favore,",
  "bd8e05cd53": "Fai clic sul pulsante per avviare la verifica intelligente.",
  "63d2a8a722": "Verifica riuscita.",
  "73141928ad": "Verifica fallita. Fai clic sul pulsante per aggiornare.",
  "04856c5c8a": "Rilevamento intelligente in corso...",
  "52cd9bd26d": "L'operazione non è autorizzata.",
  "fd157e8ea8": "Guida alla creazione",
  "c6225c5b2b": "Benvenuto in WPS Enterprise",
  "e33423fb1e": "Creato con successo",
  "7b0c035999": "Pagina di successo della creazione dell'organizzazione WPS Docs",
  "85db8faae0": "Istruzioni per l'uso della versione Enterprise",
  "20591b9b44": "Recupera nome organizzazione",
  "b023d76dc2": "Guida al caricamento dei membri",
  "e2f454e095": "Organizzazione di {0}",
  "df466f942b": "Filiale",
  "26a7b797c4": "Sottocentro",
  "5fc82b360b": "Piattaforma di servizi per l'ufficio all-in-one, per un lavoro più efficiente",
  "f2e736d52e": "Benvenuto in WPS Enterprise",
  "becc41a35b": "Nome organizzazione",
  "74685cdc58": "Inserisci il nome dell'azienda o dell'organizzazione, 4-100 caratteri",
  "07b55b1907": "Dimensioni dell'organizzazione",
  "77b2f763ad": "Seleziona le dimensioni della tua organizzazione",
  "49d2509109": "Fino a 5 persone",
  "8db2c9b74a": "6-20 persone",
  "a9fb0cf14a": "21-50 persone",
  "0fed41f8d3": "51-100 persone",
  "fb33f25a04": "101-200 persone",
  "3e3ff0f52e": "201-500 persone",
  "cd8b51f634": "501-2000 persone",
  "0662fa6eec": "Almeno 2000 persone",
  "69334dba1a": "Esigenza aziendale",
  "79994e749c": "(Consiglieremo le migliori soluzioni e pratiche di settore per le aziende)",
  "840a017f38": "Seleziona il problema che desideri risolvere prioritariamente",
  "f045b05c73": "Inserisci i requisiti per la creazione dell'azienda",
  "d8efb0b36d": "Altro",
  "adcb8fbb0c": "Numero di cellulare principale",
  "eb1c73e2ca": "Inserisci il tuo numero di cellulare di 11 cifre più usato",
  "7f276e7dfa": "Crea gratuitamente",
  "c391b3eec1": "Invio SMS non riuscito",
  "54f4cb8fa7": "SMS inviato",
  "231eb1fa1e": "Utente aziendale_{0}",
  "272b0f9d32": "Utente aziendale",
  "b209a67331": "Creazione dell'azienda non riuscita, aggiorna la pagina.",
  "acb08d0cc9": "Terzo passaggio della creazione dell'azienda",
  "83db361f51": "Dopo la creazione, attiva la logica di reindirizzamento",
  "1e930326e3": "handleStep passa al passaggio successivo",
  "184df5c725": "saveForm non riuscito",
  "736eab3023": "Invia convalida",
  "2db62dc13c": "Convalida non riuscita",
  "54fb0afaea": "Convalida riuscita",
  "d39cff3fcf": "Saltando il salvataggio estremo si scopre la necessità del codice di verifica",
  "305b777ae5": "Verifica nome non riuscita. Abilita il popup \"Nome azienda già in uso\" e memorizza il nome",
  "e57b6686b2": "Verifica se il soggetto di autenticazione è stato autenticato. Abilita il popup di protezione dell'autenticazione e memorizza le informazioni corrispondenti del soggetto di autenticazione",
  "f7c86f496d": "Nome di creazione duplicato || Codice di verifica scaduto. Se uno di questi esiste, impedisci l'esecuzione",
  "cb37db4fd4": "handleSubmit non riuscito",
  "243a569fc4": "Il nome è già registrato. Utilizza un altro nome",
  "196851a3d9": "Utente aziendale_{0}",
  "0c3a3595ff": "Utente aziendale",
  "a33b41e0f2": "Creazione azienda non riuscita. Aggiornare la pagina.",
  "fcce6a7156": "Creato con successo",
  "5ec6da58a6": "Notifica client",
  "259c9dfa4e": "Logica versione Professional",
  "864156930f": "Logica VBA",
  "7824efd172": "WPS Docs Mobile",
  "52b6cfaaaf": "Client WPS",
  "c7c51beea9": "Versione Education",
  "8d054d4986": "Client predefinito",
  "b597e18fb1": "isWps365PcClient e ha openurl",
  "b0c13de2a0": "isWps365PcClient o non-client, con openurl",
  "7d0f2ce18c": "isWps365PcClient o non-client, con callback di successo openurl",
  "e2c5a07df6": "Non-client non openurl",
  "29e0414d1f": "Callback non-client non openurl",
  "60861f7d2a": "autoChange è gestito dal lato business per il cambio",
  "7c83140d90": "Creazione dello stato visitatore. Non è necessario cambiare account tramite SDK (SDK non supporta i visitatori). Il codice ha già effettuato il cambio tramite l'interfaccia.",
  "3379b09e59": "Con openurl e usa href per il cambio",
  "586ff04c22": "Reindirizzamento separato",
  "b6c91f218b": "useSuccessSkip non riuscito",
  "47d2f3ba66": "Altro",
  "57551f86ce": "Attiva diversi metodi di reindirizzamento in base a utm_source",
  "64fe3758e2": "Operazione non autorizzata.",
  "4da3e1262f": "Creazione riuscita, inizia il tuo percorso di ufficio aziendale",
  "c38dfb8c6c": "Crea il tuo primo team",
  "38dddb483b": "Accedi all'organizzazione",
  "614d9c91eb": "Invita membri",
  "97f1eca0aa": "Accedi all'organizzazione",
  "13a4939e90": "Accetta invito all'organizzazione",
  "a319e4ae0a": "Invita colleghi a unirsi",
  "12e4da6bba": "Invita subito i colleghi",
  "bd885380f6": "Impossibile ottenere il link di invito",
  "5e626c4063": "SMS inviato",
  "3dc09e7cfd": "Il numero di nomi di organizzazione che hai richiesto di recuperare ha raggiunto il limite massimo.",
  "48318f41f9": "Invita membri",
  "45441baac4": "Ti invitiamo a unirti a {0} per collaborare.",
  "e5847fbd67": "Copia link, invita membri",
  "23101dd40a": "Stiamo personalizzando soluzioni per te",
  "71bb7e54a8": "Gestione progetti",
  "aff37c79cc": "Prova il piano selezionato",
  "a97b174258": "Invita altri <color: red>2</> colleghi e ottieni gratuitamente i seguenti vantaggi aziendali",
  "253855849f": "Condividi il link di invito nel gruppo di lavoro per invitare i colleghi",
  "57b0a2a63f": "Copia link, invita colleghi",
  "71c0a37ee1": "Accedi all'organizzazione",
  "f848c60e0e": "Invita altri <color:red>2</> colleghi e ottieni gratuitamente i seguenti vantaggi aziendali",
  "664e32b4fe": "Pagina di invito: Accedi all'organizzazione",
  "872f14403a": "Invita colleghi a unirsi",
  "1880e7deb9": "Invita subito i colleghi",
  "cc2a9aaf82": "Creazione riuscita",
  "02a13e2583": "Invita altri <color: red>2</> colleghi a unirsi e ottieni gratuitamente i seguenti vantaggi aziendali.",
  "5d3593cdce": "Impossibile ottenere le informazioni del team.",
  "c025113ea1": "Impossibile ottenere il link di invito.",
  "b83bc1e485": "Invita tramite link",
  "0996ced9f6": "Spiacenti, il browser in uso non supporta il download di questo codice QR.",
  "1e88451e31": "Link di invito copiato.",
  "bb969cabcd": "Copia non riuscita. Riprovare.",
  "15e1f79c7a": "Richiedi di unirti all'organizzazione.",
  "59c22b4ef8": "Ricevuto un link di invito.",
  "0f0b392e60": "Crea il tuo primo team.",
  "0437d07c43": "Nome dell'organizzazione",
  "41800c7bf1": "Inserire il nome del creatore.",
  "1ec5999511": "Il nome del creatore può contenere al massimo 8 caratteri.",
  "02da35b4e4": "Il nome del creatore può contenere solo caratteri cinesi, lettere e numeri.",
  "184e9f6616": "Inserire il numero di telefono.",
  "9b587898ba": "Inserire un numero di telefono nel formato corretto.",
  "e68c164a02": "Inserire il proprio indirizzo email.",
  "0b1de22df7": "Inserire un indirizzo email nel formato corretto.",
  "61026181ab": "Licenza commerciale obbligatoria.",
  "c3847e604e": "La dimensione del file supera i 10 MB. Selezionare di nuovo.",
  "49450f4ec7": "Modulo di ricorso per omonimia obbligatorio.",
  "39c3b8fa1d": "Invio non riuscito.",
  "3ea44d7963": "Caricamento riuscito.",
  "5b1aa3c2c4": "Caricamento non riuscito.",
  "7e7f81eaa3": "Caricamento non riuscito. Il file è più grande di 10 MB.",
  "2ff1913de1": "Caricamento non riuscito, il file deve essere .jpg, .jpeg, .png, .bmp, .pdf",
  "7951a879f2": "Licenza commerciale obbligatoria",
  "66bda65057": "La dimensione del file supera i 10 MB, selezionare di nuovo.",
  "8f2305a83d": "Modulo di ricorso per nome duplicato obbligatorio",
  "55ff0c8c6e": "Invio non riuscito",
  "8dad6d950d": "Impossibile ottenere le informazioni di invito.",
  "a5f0ac3a9a": "Creazione riuscita",
  "4f1d069770": "I parametri utm della pagina di invito sono {0} e il nome {1}",
  "f9578cfe6d": "I parametri utm per l'accesso alla guida in due passaggi sono {0} e il nome {1}",
  "e10d028405": "Guida in due passaggi pcoffice creata",
  "8e22e4fcc4": "Link di invito copiato",
  "3f327f9f37": "Copia non riuscita, riprovare.",
  "bd1aecb265": "Annulla",
  "b6abf9b19a": "Accetta",
  "e910d9cc0f": "Annulla",
  "37ab25522d": "Accetta",
  "196b3eb9cf": "Scansiona per unirti",
  "2b81c52e20": "Scarica immagine",
  "62152fd9f3": "Invita tramite link",
  "e0a3725651": "Spiacenti, il browser attuale non supporta il download di questo codice QR.",
  "8b7883b2c7": "Scansiona per unirti",
  "9e9a659ed5": "Scarica immagine",
  "0d55065a9a": "Invita tramite link",
  "487cf6a106": "Spiacenti, il browser attuale non supporta il download di questo codice QR.",
  "78fd005d1f": "Inserisci il numero di telefono",
  "f909563857": "Crea con questo numero",
  "a26a19f139": "Annulla creazione",
  "cc004ac9ee": "Numero di telefono",
  "4df8c3c588": "Crea una scuola con un altro numero di telefono",
  "3151cabb3d": "Crea un'azienda con un altro numero di telefono",
  "56098a71eb": "Clicca per la verifica intelligente e invia il codice di verifica",
  "e96ec218e4": "Inserisci il codice di verifica SMS",
  "ce619a0225": "Codice di verifica SMS inviato a",
  "0e9863aaeb": "Codice di verifica errato, inseriscilo di nuovo",
  "32dc8629e1": "Reinvia tra %s secondi",
  "e4eda9add5": "Reinvia",
  "b007977564": "Impossibile ottenere le informazioni di approvazione",
  "d8852ffc9c": "Accesso non amministratore",
  "8a733a2574": "Accesso da dispositivo mobile",
  "9e8c152c4f": "Accesso da PC",
  "2265a55e93": "Accetta l'accordo di servizio",
  "80dabe5aa3": "Crea guida",
  "7deee8bf5a": "Guida in due passaggi docsWeb created",
  "69eb501ecb": "Il tuo ricorso è scaduto e non è accessibile",
  "aa1d9d98ad": "Autorizzazioni insufficienti, impossibile accedere",
  "fdf2fe129e": "Crea organizzazione",
  "7f0ca0df6b": "Crea azienda",
  "cc6ac2a93c": "Guida in due passaggi Base mounted",
  "5d6c570bf0": "Guida in due passaggi beforeunload",
  "a4eb8a192d": "Team che tutti stanno creando",
  "4912e16a9d": "Nome azienda recuperato",
  "41c4e87ef2": "Puoi cliccare sul link",
  "5e630930c0": "Ricrea l'azienda",
  "436a563524": "Se hai già creato un'azienda, puoi fare riferimento a",
  "0b6e7cbe7f": "«Come modificare il nome dell'azienda»",
  "cb7bce0775": "il tutorial per modificare il nome dell'azienda",
  "3feadd3040": "La versione attuale è troppo obsoleta per usare l'azienda",
  "3cf23de936": "La tua versione del software è troppo obsoleta, le funzionalità aziendali non sono disponibili. Vai all'app store per aggiornare la versione del software!",
  "a1c5d5d202": "OK",
  "e50183bd00": "WPS Cloud Documenti",
  "e5031ab679": "Sicurezza, sincronizzazione, collaborazione",
  "c870026dfc": "Accedi con WeChat",
  "e7647cd875": "Telefono o email",
  "07b380074b": "Accedi con QQ",
  "67921724dd": "Altri metodi",
  "254da8a9f5": "Hai raggiunto il limite massimo di aziende a cui puoi unirti o crearne",
  "3648e4811b": "Vai a WPS Docs",
  "dcd102b346": "Crea un team personalizzato",
  "8b9b258cbf": "Inserisci il nome del team",
  "19bb6e0ded": "I membri WPS godono di",
  "2d9fe8d938": "privilegi d'ufficio, che ti aiutano a risolvere i problemi di documentazione quotidiani. Prova subito!",
  "e8c1caa649": "Carica da locale",
  "03641083a3": "Sposta da «Documenti personali»",
  "eecd3ab9b5": "Più tardi",
  "13b447b3a8": "Aggiorna",
  "3c2fc507fc": "La versione attuale è troppo obsoleta per utilizzare le funzionalità aziendali.",
  "c3615d8134": "La versione del software è troppo obsoleta per utilizzare le funzionalità aziendali. Visita il sito ufficiale per aggiornare il software!",
  "644a36e05b": "Aggiorna",
  "d435105f21": "È stato raggiunto il limite massimo di aziende a cui è possibile unirsi/creare.",
  "73a286ceb0": "Accedi a WPS Docs",
  "c2cec645c0": "Annulla",
  "b5f5b83c0f": "Accetta",
  "76ec352da5": "Invita colleghi scansionando il codice QR",
  "6a509e4487": "Scarica codice QR",
  "940cc4a546": "Impossibile creare un'azienda",
  "78b2a62ea5": "Accedi a un'azienda esistente o creane una nuova",
  "3a6da7f6f9": "Il numero di aziende associate al numero di telefono attuale ha raggiunto il limite massimo (max 5 aziende).",
  "93bab52870": "Il numero di telefono attuale è già associato a un'azienda, puoi scegliere un'azienda esistente per accedere:",
  "ce6e0adaf2": "Puoi scegliere di accedere a una delle aziende associate qui sotto:",
  "1ce200a92b": "Seleziona",
  "bb91ef2999": "Crea nuova azienda",
  "024e4a91e5": "Il nome dell'azienda è già registrato.",
  "eb089a23a0": "Questo nome azienda è già registrato:",
  "7646558701": "Amministratore:",
  "1d9c02bd33": "Data di registrazione:",
  "919fc7805f": "Si consiglia di provare a trovare e contattare i colleghi sopra menzionati.",
  "0ca71a9344": "È anche possibile utilizzare temporaneamente un altro nome per creare un'azienda (modificabile in seguito) e poi presentare un reclamo.",
  "e83a244e90": "Clicca per sapere come presentare un reclamo.",
  "d22bedfb21": "Conferma",
  "907b78b6e5": "Inserisci un nome per il gruppo di lavoro o il team",
  "7195b0ac1e": "Team suggeriti",
  "60ed4f915e": "Avanti",
  "f5ba8dfb7b": "Salta",
  "5c44a3ef68": "Massimo 100 caratteri",
  "130c53fb20": "Il nome non può contenere caratteri non validi o simboli speciali /\\;:*?\"<>|%&",
  "e832d41acc": "Salta guida in due passaggi",
  "80d9cf7177": "Guida in due passaggi Aggiorna",
  "0aebf80435": "Guida in due passaggi Clicca etichetta",
  "e74f515977": "Guida in due passaggi handleSubmit",
  "308d2a53c9": "Guida in due passaggi createGroup",
  "dda2ed7e18": "Guida in due passaggi: creazione team fallita",
  "ded3c35500": "Creazione team fallita",
  "4f18031bc1": "Guida in due passaggi createTemplate",
  "091e5cefcc": "Guida in due passaggi createTemplate errore",
  "58cf4e00f0": "Codice di verifica",
  "92abbf0385": "Invia codice",
  "f0f9976ef9": "Inserisci il numero di telefono",
  "a4ce99b1df": "Codice di verifica",
  "39d36e0f9f": "Conferma",
  "0fd8a01938": "Invia",
  "9048a4e842": "Numero di telefono",
  "9afa1091eb": "Reinvia",
  "58d787001f": "Inserisci un altro numero di telefono per creare una scuola",
  "450905a265": "Inserisci un altro numero di telefono per creare un'azienda",
  "f7386de3c6": "Selezione a discesa",
  "27aa05a92c": "Accetta il contratto di servizio",
  "80af61cb57": "Torna alla pagina precedente",
  "50149b8d4f": "Nome del richiedente",
  "e6756f8749": "Inserisci il tuo nome",
  "3cbd51a2b1": "Il nome deve contenere almeno 2 caratteri. Inserisci un nome di 2-10 caratteri.",
  "4f79b4813f": "Il nome supporta solo caratteri cinesi, numeri, inglese e '·'.",
  "71d3e75983": "Numero di cellulare principale",
  "afe5149035": "Inserisci il tuo numero di cellulare principale",
  "1e9270b50f": "Inserisci il tuo numero di cellulare principale, 11 cifre.",
  "ff5dc98dfb": "Salta",
  "165be2ab43": "Torna indietro",
  "231d8a335a": "Accetta il contratto di servizio",
  "1cad008ffc": "Il nome dell'azienda {0} è già registrato, utilizza un altro nome.",
  "c6e274fcab": "Conferma accordo",
  "b9352504bb": "Chiudi il pop-up dell'accordo",
  "8409e99ad0": "Apri il pop-up dell'accordo",
  "1593c6dd95": "Invia",
  "4f44a9de22": "Abilita verifica SMS",
  "26b70c68b8": "Salta e accedi direttamente all'organizzazione",
  "a8bebcb302": "Torna alla pagina precedente",
  "c800b4fec5": "Pagina di invito Base Mounted",
  "38b396d5b0": "Pagina di invito docsWeb Mounted",
  "2eb7f9a9f1": "Il tuo reclamo è stato inviato con successo.",
  "2c6f3590fb": "Prevediamo di inviare i risultati dell'elaborazione alla tua email entro 3 giorni lavorativi",
  "2ea3eff708": ", si prega di verificare.",
  "53acfba22c": "Invita subito i colleghi",
  "4e6d282f4f": "Invito a unirti all'azienda",
  "5f72f4b936": "Invita subito i colleghi",
  "e5383077ba": "Recupera nome azienda",
  "06e3fa2350": "Dopo la verifica,",
  "653a263b5e": "il creatore è",
  "769f57269f": "Numero di cellulare del creatore:",
  "09a224695e": "Conferma se il creatore di questa azienda è un tuo collega.",
  "3beda6c149": "· Se è un tuo collega, puoi contattarlo.",
  "5c74dd10d1": "Modifica il nome dell'azienda o trasferisci il super amministratore.",
  "da504edb0f": "· Se non è un tuo collega, puoi cliccare il pulsante qui sotto per continuare a recuperare il nome dell'azienda.",
  "39194faaf1": "Continua a recuperare il nome dell'azienda",
  "e22b829e90": "Copia riuscita",
  "6e1b44752a": "Valore TXT",
  "79881b1d7a": "Invita subito i colleghi",
  "a5344a45f9": "Clicca in alto a destra e seleziona [Invia agli amici].",
  "a4954a5b08": "Invita subito i colleghi",
  "8e3a1625fb": "Recupera nome azienda",
  "bf8b8c7005": "Carica licenza commerciale dell'azienda",
  "bfd44a66c9": "Seleziona",
  "d503f20925": "Carica una scansione o una foto della licenza commerciale dell'azienda.",
  "cbebe043c5": "Supporta i formati JPG, JPEG, PNG, BMP, PDF, con una dimensione massima di 10 MB.",
  "9650b96d7d": "Carica il modulo di reclamo per nome duplicato",
  "c3b8ae46d3": "Carica una scansione o una foto del modulo di reclamo per nome duplicato.",
  "9e325a9e09": "Scarica il modello del modulo informativo",
  "a4711aae88": "Invia richiesta",
  "3a5cc1441e": "Autenticazione in corso...",
  "0bd7bf8511": "Al momento non possiamo verificare il tuo dominio. Potrebbe essere necessario attendere ancora un po' affinché il provider di hosting del dominio aggiorni le tue informazioni. Se dopo un po' di tempo non ci sono ancora risposte, prova a verificare di nuovo o a cambiare il dominio.",
  "fae48d554b": "Verifica del dominio in corso",
  "5e1779a0ca": "i record di verifica. Puoi chiudere questa pagina e tornare più tardi per controllare.",
  "ca85f8b836": "Benvenuto in WPS Enterprise",
  "2570e0f00b": "Accesso non riuscito",
  "40d16a007e": "Il tuo account personale è stato associato automaticamente.",
  "81376b92e4": "Il metodo di accesso di {0}. Effettua nuovamente l'accesso per cambiare l'account aziendale.",
  "ba679ba739": "Capito, accedi.",
  "c05f64c6c6": "Accedi automaticamente dopo {0}.",
  "c329ccef3a": "Errore di accesso",
  "e370f9afb1": "Il tuo account personale è stato collegato automaticamente.",
  "410cf42585": "metodo di accesso. Effettua nuovamente l'accesso per cambiare l'account aziendale.",
  "062d48aece": "Capito, accedi.",
  "95a105d412": "Accedi automaticamente in seguito.",
  "2d000d5a6d": "Invia il link di condivisione ai membri; dopo averlo aperto, potranno richiedere di unirsi.",
  "8861b6e90d": "Entra nell'organizzazione",
  "25b9f72fda": "Errore nei parametri della pagina.",
  "1c76123efc": "Impossibile ottenere il link di invito.",
  "6caba48b76": "Salta",
  "f66379c650": "Errore nei parametri della pagina.",
  "c45021de2a": "Creazione non riuscita.",
  "011d470126": "La piattaforma protegge costantemente la sicurezza delle tue informazioni.",
  "f1a44d9151": "La piattaforma ha ottenuto le certificazioni ISO27001 e ISO27701 rilasciate dall'organismo internazionale BSI e ha superato la valutazione di qualificazione della sicurezza di Livello 3 per la protezione classificata della sicurezza informatica nazionale--",
  "255ea5dff7": "White paper sulla sicurezza",
  "bb55b124f2": "Crea una presentazione aziendale",
  "61e24974a3": "Crea un'organizzazione per accedere ai contenuti della policy.",
  "bfdf78febe": "Avanti: completa le informazioni.",
  "c4aa2d2d60": "Inserisci il nome del gruppo di lavoro o del progetto.",
  "b69765ab64": "Team che tutti stanno creando.",
  "9657d9408b": "Aggiorna",
  "e21da8c16a": "Avanti",
  "224ef5cc9f": "Salta guida",
  "641f58c8f6": "L'organizzazione attuale non consente ai membri di creare team. Contattare l'amministratore per la creazione.",
  "efea622752": "Copia il link e invita i colleghi",
  "fd5b40a9fd": "Sei invitato a unirti a «{0}» per collaborare.",
  "b04dd2f10a": "Link di invito copiato",
  "d1606a1b1a": "Copia non riuscita. Riprova.",
  "0d59f3db83": "Inserisci il dipartimento o il team del progetto, ad esempio \"Reparto vendite\".",
  "9429513d34": "Nessuna guida necessaria",
  "b54a20b1ff": "Creazione fallita",
  "093fa0fb74": "Accesso e autorizzazione in corso...",
  "b383b136f4": "Inizializzazione creazione progetto aziendale",
  "b6b21b388b": "Il nome dell'organizzazione è già registrato",
  "285dc68c10": "Questo nome organizzazione è già registrato:",
  "1bf685b89d": "Amministratore:",
  "7b4297edcc": "Data di registrazione:",
  "fa51ea19fc": "Si consiglia di provare a cercare e contattare i colleghi sopra menzionati.",
  "e3678a996d": "È anche possibile utilizzare temporaneamente un altro nome per creare un'organizzazione (modificabile in seguito) e quindi inviare un reclamo.",
  "5969bc8071": "OK",
  "ba4cf699df": "Recupera nome organizzazione",
  "afecee4eb4": "Il tuo nome",
  "a8bdebc614": "Inserisci il tuo nome",
  "5bbeb38a66": "Numero di telefono",
  "b4f7b44b7a": "Inserisci il tuo numero di telefono",
  "cac2913686": "Email di contatto",
  "23d3bb3a42": "Inserisci la tua email di contatto",
  "ea106a393c": "Carica il certificato di registrazione dell'impresa.",
  "f74131d71e": "Fai clic per selezionare.",
  "53749c51c5": "Si prega di caricare una scansione o una foto del certificato di registrazione dell'impresa.",
  "c00f2ea171": "Sono supportati i formati JPG, JPEG, PNG, BMP e PDF, con una dimensione massima di 10 MB.",
  "57ec07fa97": "Carica il modulo informativo di ricorso per nome duplicato.",
  "8eb0606e94": "Si prega di caricare una scansione o una foto del modulo informativo di ricorso per nome duplicato.",
  "f59e76c0b0": "Scarica il modello del modulo informativo.",
  "030bd26fa4": "Invia richiesta.",
  "0a602dc727": "Archiviazione sicura dei dati.",
  "9138f28acf": "Condivisione e collaborazione sui file.",
  "b3a306cf90": "Conformità e regolarizzazione.",
  "973c53f725": "Si consiglia di modificare il nome. Dopo la registrazione, è possibile inviare la certificazione dell'organizzazione e aggiornare il nome.",
  "f886f5e92f": "Si consiglia di modificare il nome. Dopo la registrazione, è possibile inviare la certificazione aziendale e aggiornare il nome.",
  "b8051702a3": "Il nome contiene parole sensibili. Si prega di modificare il nome o di contattare il servizio clienti.",
  "d73881f7d4": "Il nome dell'impresa è protetto.",
  "dc7e58e320": "Il nome dell'impresa è protetto. Prima dell'uso è necessaria la verifica delle informazioni del soggetto. Si consiglia di modificare il nome dell'impresa, oppure di utilizzarlo dopo aver completato la certificazione aziendale dopo la registrazione.",
  "20c3bc070c": "Conferma.",
  "c4278e5f28": "Autorizzazioni insufficienti.",
  "9217efae21": "L'account con cui hai effettuato l'accesso non ha l'autorizzazione per creare. Si prega di contattare il personale di vendita per assistenza.",
  "52ff08f2ad": "Il nome dell'organizzazione è protetto. Si prega di modificare il nome dell'impresa.",
  "79386ae280": "Inserisci un codice di verifica di 6 cifre.",
  "d7b2c5a41b": "Il codice di verifica è stato inviato a",
  "ce2e1c26f7": "(Valido entro 10 minuti)",
  "59d338903f": "Potrai richiedere nuovamente il codice di verifica tra {0} secondi.",
  "5aadd14136": "Richiedi nuovamente il codice di verifica.",
  "90f5c93432": "Questo nome è già registrato.",
  "1677072f4a": "È possibile fornire maggiori informazioni o registrarsi con un altro nome.",
  "3b8459fb1e": "Compilazione rapida:",
  "6f38edbcb1": "Registra con questo nome",
  "8406c81e2d": "Filiale",
  "29d323fa85": "Sottocentro",
  "4f0e806e02": "Finanza",
  "3f935efb6b": "Accetta l'accordo di servizio",
  "b42241be05": "Non ora",
  "99de4b33b7": "Accetta",
  "7f867e7395": "Crea un'azienda con un altro numero di telefono",
  "0d51a8f7a6": "Continua a creare",
  "8bdaecf2e5": "Inserisci il tuo numero di telefono",
  "565ae60c8a": "Inserisci il tuo nome",
  "f76e06d0e7": "Inserisci il tuo numero di telefono",
  "7b0fca5255": "Inserisci il codice di verifica",
  "68026d2d25": "Benvenuto nell'edizione Enterprise",
  "d25b5541be": "Crea gratuitamente",
  "32cfd73733": "Inserisci il nome del tuo team, azienda o organizzazione",
  "4cf83dc4a0": "Crea rapidamente in un minuto e collabora in modo efficiente con i colleghi.",
  "d320d37116": "Crea team/aziende gratuitamente",
  "c54b475dd2": "Accordo per l'utente",
  "190d54e616": "Azienda di {0}",
  "8c1b768ac4": "Verifica intelligente fallita",
  "d74eab0f35": "Il nome dell'azienda inserito non è conforme agli standard della piattaforma. Modificalo e riprova.",
  "0f3d62dd4f": "Le informazioni inserite per il nome non sono conformi alle specifiche della piattaforma. Modificale e riprova.",
  "647cf2211b": "La creazione con questo numero di telefono non è supportata. Cambia numero di telefono.",
  "b63d96cdae": "Le informazioni inserite non sono conformi alle specifiche della piattaforma. Modificale e riprova.",
  "2dbbe8e43f": "La creazione con questo numero di telefono non è supportata. Modifica e riprova.",
  "b18abc5de6": "Nessun numero di telefono collegato.",
  "f5233dae6f": "Cambia numero di telefono per la creazione.",
  "4167c8b88d": "Il numero di telefono attuale potrebbe presentare le seguenti situazioni. Prova a cambiarlo per la creazione. Per qualsiasi domanda, contatta il servizio clienti.",
  "a8a2433c4d": "Scansiona il codice QR WeChat per aggiungere e contatta il servizio clienti.",
  "444a639c09": "Ho capito.",
  "69a097057f": "Il numero di telefono attuale appartiene a un <#BB2726>segmento di numero di operatore virtuale<#BB2726>.",
  "4370b06fd0": "Il numero di telefono attuale presenta un <#BB2726>comportamento di utilizzo anomalo<#BB2726>.",
  "8c49e1dc4a": "È richiesta la verifica umana.",
  "4b8ba7d8cc": "Piattaforma per la produttività di nuova generazione per l'ufficio.",
  "81be771e17": "🎉Azienda creata con successo! Completa le informazioni per ottenere servizi esclusivi.",
  "461125b057": "Gestisci documenti e materiali nel team. I membri del team possono visualizzarli facilmente e impostare autorizzazioni di modifica/download per garantire la sicurezza dei dati.",
  "c3eb25029b": "Dimensioni dell'azienda/del team",
  "049f8401ec": "Meno di 5 persone",
  "c81896349e": "6-20 persone",
  "7357daac4e": "21-50 persone",
  "f0e65a0a29": "51-100 persone",
  "b9fac8204a": "101-200 persone",
  "62d73dddaf": "201-500 persone",
  "3bcdaf7160": "501-2000 persone",
  "ab0b2333fe": "Oltre 2000 persone",
  "4f756eedc8": "Il tuo ruolo è",
  "3ba0b502c3": "Direttore generale",
  "702099cc72": "Finanza",
  "843b603162": "Acquisti",
  "8b414a9b44": "Risorse Umane/Amministrazione",
  "92486b2908": "Vendite",
  "ac4e7fb063": "La tua organizzazione ha un budget/piano di acquisto per software per ufficio?",
  "37634c72dc": "Entro sei mesi",
  "bd94b6deec": "Entro 1 anno",
  "713f4aad5c": "In fase di valutazione",
  "c5ea095a4d": "Nessun piano per ora",
  "2409099a69": "<img src=\"https://ks3-wpsplus-prod.wpscdn.cn/e2546275-3953-40b4-8933-9ff6f0a1aeb4.png\"> Crea un team, invita i membri a collaborare",
  "9d27dc2d90": "Puoi inserire il nome del tuo team o i progetti seguiti di recente",
  "de19c8509a": "Potresti voler creare:",
  "1a84699223": "Reparto Vendite",
  "efab59502b": "Reparto Prodotti",
  "7e599b3713": "Reparto Operazioni Sud",
  "bf494779c2": "Reparto Acquisti",
  "f3a60ab34d": "Reparto Amministrazione",
  "bbc50c1ac8": "Reparto Finanza Nord",
  "32629e3dac": "Reparto Finanza Prodotti",
  "5524d354ba": "Reparto IT",
  "0ccda29a0d": "🎁<span style='color: rgb(206,131,62);'>Hai sbloccato i vantaggi per i nuovi utenti!</span> Invita altri 3 utenti per ottenere <span style='color: rgb(206,131,62);'>4 TB di spazio e i vantaggi di WPS AI</span>.",
  "939eb98492": "<span style='color: rgb(206,131,62);'>Hai sbloccato il limite di 50 persone e i vantaggi di caricamento di file singoli fino a 4 GB</span>. Continua a invitare 3 persone per sbloccare 30 giorni di WPS AI e 4 TB di spazio con vantaggi premium.",
  "136c26d941": "Copia il link qui sotto per invitare i membri",
  "3de5c12558": "Copia link, invita colleghi",
  "a5d64b14f3": "Guida alle informazioni aziendali",
  "b8f2492701": "Raccolta informazioni aziendali",
  "1f9d053dc0": "Crea modello team",
  "0e83c79a88": "Invita membri",
  "821fc1906a": "Accedi all'organizzazione",
  "463e14ae9c": "Seleziona un team",
  "690f0cdb9e": "Icona di completamento",
  "c340522a17": "Indietro",
  "f9355c72ef": "Salta",
  "bd6c09ebbb": "Avanti",
  "2a2603cd3f": "Scansiona il codice QR per inviare l'invito ai colleghi",
  "411e64907a": "Copia",
  "b0d988cf23": "Scarica",
  "e3c0b650ac": "Copiato",
  "713ac624b4": "Benvenuto in WPS 365",
  "b8fff97849": "Elemento di destinazione non valido",
  "02acdcf296": "Conversione html2canvas non riuscita, canvas non generato",
  "a76988c496": "Conversione da canvas a blob non riuscita",
  "af89584edf": "API Appunti non disponibile",
  "f90263bbde": "Copia immagine non riuscita",
  "71b05319da": "Conversione da HTML a canvas non riuscita",
  "38852999fe": "Salvataggio informazioni non riuscito",
  "4a4c621d07": "Creazione team non riuscita, riprova più tardi",
  "d239a23994": "Questa pagina è accessibile solo agli account aziendali. Accedi prima con un account aziendale.",
  "d93bfb7fb9": "Inserisci contenuto",
  "42b81a66c4": "Lunghezza tra 2 e 100 caratteri",
  "76d33733db": "Non può contenere caratteri speciali come / \\ ; : * ? \" < > | % &",
  "dc55d1f62f": "Prova ora",
  "b25233cba0": "Collaborazione documenti e messaggistica istantanea: un nuovo modo per lavorare in modo efficiente.",
  "f0e563652d": "<img src=\"https://vasvip-pub.wpscdn.cn/prod/SAAS-UG/atomic_guidance/icon/woa_logo_l.png\"> Avvia chat di gruppo collaborative, condivisione documenti sicura e comoda.",
  "1e484cce68": "<img src=\"https://vasvip-pub.wpscdn.cn/prod/SAAS-UG/atomic_guidance/icon/lingxi_normal.png\"> Lingxi AI Assistant, l'assistente intelligente progettato per l'ufficio.",
  "e338385bc9": "Soluzione AI nativa per Office, che integra profondamente l'IA e il software per ufficio, per dare a tutti un assistente AI.",
  "7ae1f3b1c6": "Importazione di file (e cartelle) completata. È possibile visualizzare i risultati dell'importazione in 'I miei documenti cloud'.",
  "85db2a024a": "Importazione di file (e cartelle) non riuscita. Riprovare più tardi.",
  "9ff74c802a": "Scarica la versione per chip Intel",
  "ab44928f02": "Scarica la versione per chip Apple",
  "a08d937c38": "Caricamento file (e cartelle) in corso. Al termine, è possibile visualizzarli in 'I miei documenti cloud'.",
  "68db1829fa": "L'importazione è supportata solo da account personali. Accedere con un account personale e riprovare.",
  "1185a7c7ab": "Meno di 20 persone",
  "e2bcc252c9": "21-300 persone",
  "3c4842f1ea": "301-1000 persone",
  "1bbee64cfa": "Più di 1000 persone",
  "388ff4a035": "Insegnante",
  "d341b1d794": "Studente",
  "bfb2ee4148": "Altro",
  "f6450c3f31": "Gestione progetti",
  "b87fd33a0d": "Piano annuale",
  "0dd45a1c14": "Gestione delle prestazioni dei dipendenti",
  "67fa01cac6": "Attività di marketing",
  "6dd82cc031": "Reclutamento del personale",
  "a7edaed91d": "Materiale didattico",
  "bf12b7efb0": "Gestione dei piani didattici",
  "c35ae8f358": "Documentazione del prodotto",
  "343f236a78": "<img src=\"https://vasvip-pub.wpscdn.cn/prod/SAAS-UG/atomic_guidance/icon/dbsheet.png\"> WPS Foglio di calcolo multidimensionale, crea visivamente il tuo sistema aziendale personalizzato",
  "72286d5519": "👏 Modelli consigliati",
  "0bc00ee949": "Gestione requisiti e difetti",
  "e22f3d56f7": "Gestione della creazione di contenuti",
  "dd439de3dd": "Sistema di gestione clienti",
  "fbb2bbf82e": "Piano di preparazione agli esami",
  "0645b908bc": "Consultazione buste paga",
  "813b3d3d7e": "Gestione OKR",
  "918e33d5bd": "Crea con un clic",
  "ebf9cfb7ef": "<img src=\"https://vasvip-pub.wpscdn.cn/prod/SAAS-UG/atomic_guidance/icon/import_files.png\"> Importa documenti di uso comune, per un utilizzo più pratico",
  "c58f28713c": "Importa da locale",
  "9d6a0a4370": "Supporta i formati di file Office più comuni",
  "54c48aee85": "Seleziona file",
  "c5b593e452": "Importa da account personale",
  "4bdcd9d4c5": "Importa con un clic documenti, team e cartelle dell'account personale",
  "99b2968905": "Autorizza importazione",
  "472f818a23": "<img src=\"https://vasvip-pub.wpscdn.cn/prod/SAAS-UG/atomic_guidance/icon/woa_logo_l.png\"> Scarica il client di collaborazione WPS",
  "fe46574227": "Collaborazione documenti + messaggistica istantanea, un nuovo modo per lavorare in modo efficiente",
  "beefe5a09b": "Scarica ora",
  "278839c7b1": "<img src=\"https://vasvip-pub.wpscdn.cn/prod/SAAS-UG/atomic_guidance/icon/woa_logo_l.png\"> Ricche impostazioni di sicurezza per garantire la protezione dei dati",
  "b4e70dbeab": "Anni di esperienza di WPS nelle capacità di sicurezza dei documenti, per garantire che i dati aziendali critici non vengano divulgati",
  "42dc772619": "File troppo grande, si consiglia di riprovare a importare più tardi dalla homepage",
  "a052564e47": "Errore di creazione, riprova più tardi",
  "790d0c428c": "Accedi all'area di lavoro"
}